import BossModel from "@/models/BossModel";
import WebsiteProductTagType from '@/models/WebsiteProduct/Tag/Type/Type'
import MediaLibraryItem from "@/models/Media/Library/Item/MediaLibraryItem";

export default class WebsiteProductTag extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-product/tag';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteProductTags';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            website_product_tag_type_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            media_library_item_id: this.number(null).nullable(),
            mediaLibraryItem: this.belongsTo(MediaLibraryItem, 'media_library_item_id'),
            type: this.belongsTo(WebsiteProductTagType, 'website_product_tag_type_id'),
            // mediaLibraryItem: MediaLibraryItem,
        }
    }

    /**
     *
     * @param params
     * @returns {*}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .with(['type'])
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Type() {
        return this.getRelated('type');
    }
}
